export default __webpack_public_path__ + "static/media/gb.ba1c7f5d.svg";